/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  CardActionArea,
  Grid,
  Pagination,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { fetchSales, clearAlerts, setSelectedSale ,clearSalesData} from "../store/salesSlice"; // Adjust the path as necessary
import { DocumentIdName } from "../services/Enums";
import { socket } from "../services/Api";
import useSaleDocument from "../services/useSaleDocument";
import { fetchMouvementTypeById } from "../store/mouvementTypesSlice";


const OrderCard = ({ order, onClick }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case "PENDING":
        return "red";
      case "IN PROGRESS":
        return "orange";
      case "COMPLETE":
        return "green";
      default:
        return "gray";
    }
  };

  const styles = {
    card: {
      minWidth: 275,
      backgroundColor: getStatusColor(order.status),
      transition: "transform 0.3s, box-shadow 0.3s",
      "&:hover": {
        transform: "scale(1.05)",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
      },
    },
  };

  return (
    <Grid item xs={12} sm={6} md={4}>
      <Card sx={styles.card}>
        <CardActionArea onClick={() => onClick(order?._id)}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Numero: {order.numero}
            </Typography>
            <Typography variant="body1" gutterBottom>
              Client: {order?.clientFournisseur?.name}
            </Typography>
            <Typography variant="body2">Total: ${order.total}</Typography>
            <Typography variant="body2">
              Nombre colis: ${order.colisage}
            </Typography>
            <Typography variant="body2">
              Nombre Article: ${order.number_different_articles}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </Grid>
  );
};
const SaleOrders = () => {
  const pageSize = 50;
  const { openSaleDocument, SaleDialog } = useSaleDocument();

  const { sales, message, pagination } =
    useSelector((state) => state.sale) || {};
  const { selectedShop } = useSelector((state) => state.shop) || {};
  const { selectedMouvement } = useSelector((state) => state.mouvementTypes) || {};

  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [selectedStatuses, setSelectedStatuses] = useState([
    "PENDING",
    "IN PROGRESS",
  ]);
  const [filter, setFilter] = useState({
    shop: selectedShop?._id,
    mouvementTypes: DocumentIdName.ORDRE_DE_LIVRAISON,
    status: selectedStatuses,
  });

  const generateRequestPayload = (page) => ({
    page: page,
    limit: pageSize,
    shop: filter.shop,
    status: filter.status,
    mouvementTypes: filter.mouvementTypes,
  });

  useEffect(() => {
    dispatch(fetchSales(generateRequestPayload(page)));
  }, [dispatch, page, filter]);

  useEffect(() => {
    socket.on("new-order", () => {
      dispatch(fetchSales(generateRequestPayload(page)));
    });

    return () => {
      socket.off("new-order");
    };
  }, []);

  useEffect(() => {
    dispatch(fetchSales(generateRequestPayload(page)));
    dispatch(fetchMouvementTypeById(DocumentIdName.ORDRE_DE_LIVRAISON))

    return () => {
      dispatch(clearAlerts());
       dispatch(clearSalesData())
    };
  }, []);

  useEffect(() => {
    if (selectedShop?._id) {
      setFilter((prevFilter) => ({
        ...prevFilter,
        shop: selectedShop._id,
      }));
    }
    dispatch(clearAlerts())
  }, [message, selectedShop]);

  const handleCardClick = async (order) => {
    await dispatch(setSelectedSale(order));
    openSaleDocument(selectedMouvement,order,true);
  };



 

  const handlePageChange = (event, value) => {
    if (value >= 1 && value <= pagination.totalPages) {
      setPage(value);
    }
  };

  const handleStatusChange = (event) => {
    const selectedStatuses = event.target.value;
    setSelectedStatuses(selectedStatuses);
    setFilter((prevFilter) => ({
      ...prevFilter,
      status: selectedStatuses,
    }));
  };

  return (
    <div style={{ padding: "20px" }}>
      <div style={{ width: "35%" }}>
        <FormControl fullWidth style={{ marginBottom: "20px" }}>
          <InputLabel id="status-filter-label">Filter by Status</InputLabel>
          <Select
            labelId="status-filter-label"
            id="status-filter"
            multiple
            value={selectedStatuses}
            onChange={handleStatusChange}
            label="Filter by Status"
          >
            <MenuItem value="PENDING">PENDING</MenuItem>
            <MenuItem value="IN PROGRESS">IN PROGRESS</MenuItem>
            <MenuItem value="COMPLETE">COMPLETE</MenuItem>
            <MenuItem value="CANCELLED">CANCELLED</MenuItem>
          </Select>
        </FormControl>
      </div>

      {sales?.length > 0 ? (
        <>
          <Grid container spacing={3}>
            {sales.map((order) => (
              <OrderCard
                key={order._id}
                order={order}
                onClick={() => handleCardClick(order)}
              />
            ))}
          </Grid>
          <Grid container justifyContent="center" marginTop={2}>
            <Pagination
              count={pagination ? pagination.totalPages : 1}
              page={page}
              onChange={handlePageChange}
              color="primary"
            />
          </Grid>
        </>
      ) : (
        <Typography variant="h6" align="center" style={{ marginTop: "20px" }}>
          No sales orders to display.
        </Typography>
      )}
      {SaleDialog}
    </div>
  );
};

export default SaleOrders;
